<template>
  <EuiGridRow class="w-full">
    <EuiBlock :title="`${title} - Recherche`" >
        <form @submit.prevent="launchSearch">
          <EuiGridRow>
            <EuiGridColumn class="mr-2">
              <EuiGridRow >
                <EuiTextField
                    label="Via userId"
                    v-model="oneFieldSearch.userId"
                    :invalid="oneFieldSearch.userId !== '' && formHasError()"
                    adaptSize
                    placeholder="doit être une chaine de caractère"/>
              </EuiGridRow>
              <EuiGridRow >
                <EuiTextField
                    label="via email"
                    v-model="oneFieldSearch.email"
                    :invalid="oneFieldSearch.email !== '' && formHasError()"
                    adaptSize
                    placeholder="doit être une chaine de caractère" />
              </EuiGridRow>
              <EuiGridRow >
                <EuiTextField
                    label="via login"
                    v-model="oneFieldSearch.login"
                    :invalid="oneFieldSearch.login !== '' && formHasError()"
                    adaptSize
                    placeholder="Doit être une chaine de caractère"/>
              </EuiGridRow>
              <EuiGridRow   >
                <EuiTextField
                    label="via eFoliaId"
                    v-model="oneFieldSearch.eFoliaId"
                    :invalid="oneFieldSearch.eFoliaId !== '' && formHasError()"
                    adaptSize
                    placeholder="Doit être une chaine de caractère"/>
              </EuiGridRow>

            </EuiGridColumn>
            <EuiGridColumn class="ml-2">
              <EuiGridRow >
                <EuiTextField
                    label="via employeur"
                    v-model="multiFieldSearch.organizationName"
                    :invalid="multiFieldSearch.organizationName !== '' && formHasError()"
                    adaptSize
                    placeholder="Doit être une chaine de caractère"/>
              </EuiGridRow>
              <EuiGridRow  >
                <EuiTextField
                    label="via nom"
                    v-model="multiFieldSearch.lastname"
                    :invalid="multiFieldSearch.lastname !== '' && formHasError()"
                    adaptSize
                    placeholder="Doit être une chaine de caractère"/>
              </EuiGridRow>
              <EuiGridRow>
                <EuiTextField
                    label="via prénom"
                    v-model="multiFieldSearch.firstname"
                    :invalid="multiFieldSearch.firstname !== '' && formHasError()"
                    adaptSize
                    placeholder="Doit être une chaine de caractère"/>
              </EuiGridRow>
              <EuiGridRow >
                <EuiTextField
                    label="via numéro de téléphone"
                    v-model="multiFieldSearch.phoneNumber"
                    :invalid="multiFieldSearch.phoneNumber !== '' && formHasError()"
                    adaptSize
                    placeholder="Doit être un numéro de téléphone valide"
                />
              </EuiGridRow>

              <EuiGridRow>
                <EuiTextField
                    label="via code d'activation"
                    v-model="multiFieldSearch.activationCode"
                    :invalid="multiFieldSearch.activationCode !== '' && formHasError()"
                    adaptSize
                    placeholder="Doit être une chaine de caractère"/>
              </EuiGridRow>
            </EuiGridColumn>
          </EuiGridRow>

          <EuiGridRow justify="end" class="my-5" >
            <EuiButton
                color="primary"
                variant="text"
                type="button"
                @click.prevent="clearField">
              Réinitialiser
            </EuiButton>
            <EuiButton
                :disabled="isDisabledButtonSearch"
                color="primary"
                variant="raised"
                type="submit">
              Rechercher
              <EuiTooltip v-show="formHasError()" :content="getErrorMessage" placement="top">
                <template slot="anchor">
                  <EuiIcon class="eui-u-ml-4" name="help" size="medium"/>
                </template>
              </EuiTooltip>
            </EuiButton>
          </EuiGridRow>
        </form>
    </EuiBlock>
  </EuiGridRow>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'components.searchCard',
  data() {
    return {
      oneFieldSearch: {
        login: '',
        email: '',
        eFoliaId: '',
        userId: '',
      },
      multiFieldSearch: {
        lastname: '',
        firstname: '',
        phoneNumber: '',
        activationCode: '',
        organizationName: '',
      },
      isUniqueFieldSearch: false,
      isMultiFieldSearch: false,
      errors: {
        doubleFieldCompleted: false,
        isNotAnInteger: false,
        isInvalidPhoneNumber: false,
        isOnlyOneTypeSearch: false,
      },
      errorsMessage: [
        { type: 'doubleFieldCompleted', message: 'Un seul champs doit être complété.' },
        { type: 'isNotAnInteger', message: 'Le champ userId doit être un nombre.' },
        { type: 'isInvalidPhoneNumber', message: 'Le champ numéro de téléphone doit être un numéro de téléphone valide.' },
        { type: 'isOnlyOneTypeSearch', message: 'Un seul type de champs doit être complété (gauche OU droite)' },
      ],
    };
  },
  props: {
    title:
        {
          type: String,
          default: '',
        },
  },
  computed: {
    ...mapGetters({
      getterSession: 'auth/session',
    }),
    getErrorMessage() {
      const firstError = Object.entries(this.errors).find(([key, value]) => value);
      if (firstError === undefined) return '';
      const errorMessage = this.errorsMessage.find(element => element.type === firstError[0]);
      return (errorMessage !== undefined) ? errorMessage.message : '';
    },
    searchByUserId() {
      return this.oneFieldSearch.userId;
    },
    searchByLogin() {
      return this.oneFieldSearch.login;
    },
    searchByEmail() {
      return this.oneFieldSearch.email;
    },
    searchByEfoliaId() {
      return this.oneFieldSearch.eFoliaId;
    },
    searchByLastname() {
      return this.multiFieldSearch.lastname;
    },
    searchByFirstname() {
      return this.multiFieldSearch.firstname;
    },
    searchByPhoneNumber() {
      return this.multiFieldSearch.phoneNumber;
    },
    searchByActivationCode() {
      return this.multiFieldSearch.activationCode;
    },
    searchByOrganizationName() {
      return this.multiFieldSearch.organizationName;
    },
    isDisabledButtonSearch() {
      if (this.isUniqueFieldSearch) {
        let check = true;
        Object.values(this.oneFieldSearch)
          .forEach((field) => {
            if (field !== '' && !this.formHasError()) {
              check = check && false;
            }
          });
        return check;
      }
      if (this.isMultiFieldSearch) {
        return !Object.values(this.multiFieldSearch)
          .some(value => value !== '') || this.formHasError();
      }
      return true;
    },
  },
  watch: {
    searchByUserId() {
      if (this.searchByUserId !== '') {
        this.isUniqueFieldSearch = true;
      } else {
        this.resetSingleSearch();
      }
      this.resetResult();
      this.checkOnlyOneTypeSearch();
      this.checkOnlyOneFieldCompleted();
    },
    searchByEmail() {
      if (this.searchByEmail !== '') {
        this.isUniqueFieldSearch = true;
      } else {
        this.resetSingleSearch();
      }
      this.resetResult();
      this.checkOnlyOneTypeSearch();
      this.checkOnlyOneFieldCompleted();
    },
    searchByLogin() {
      if (this.searchByLogin !== '') {
        this.isUniqueFieldSearch = true;
      } else {
        this.resetSingleSearch();
      }
      this.resetResult();
      this.checkOnlyOneTypeSearch();
      this.checkOnlyOneFieldCompleted();
    },
    searchByEfoliaId() {
      if (this.searchByEfoliaId !== '') {
        this.isUniqueFieldSearch = true;
      } else {
        this.resetSingleSearch();
      }
      this.resetResult();
      this.checkOnlyOneFieldCompleted();
      this.checkOnlyOneTypeSearch();
    },
    searchByFirstname() {
      if (this.searchByFirstname !== '') {
        this.isMultiFieldSearch = true;
      } else {
        this.resetMultiSearch();
      }
      this.resetResult();
      this.checkOnlyOneTypeSearch();
    },
    searchByLastname() {
      if (this.searchByLastname !== '') {
        this.isMultiFieldSearch = true;
      } else {
        this.resetMultiSearch();
      }
      this.resetResult();
      this.checkOnlyOneTypeSearch();
    },
    searchByPhoneNumber() {
      if (this.searchByPhoneNumber !== '') {
        this.isMultiFieldSearch = true;
      } else {
        this.resetMultiSearch();
      }
      this.resetResult();
      this.checkPhoneNumberIsValid();
      this.checkOnlyOneTypeSearch();
    },
    searchByActivationCode() {
      if (this.searchByActivationCode !== '') {
        this.isMultiFieldSearch = true;
      } else {
        this.resetMultiSearch();
      }
      this.resetResult();
      this.checkOnlyOneTypeSearch();
    },
    searchByOrganizationName() {
      if (this.searchByOrganizationName !== '') {
        this.isMultiFieldSearch = true;
      } else {
        this.resetMultiSearch();
      }
      this.resetResult();
      this.checkOnlyOneTypeSearch();
    },
  },
  methods: {
    ...mapActions({
      storeSearchMatches: 'boxes/getMatchesBoxes',
      storeStartLoading: 'application/startLoading',
      storeFinishLoading: 'application/finishLoading',
      storeStartSearch: 'application/startSearch',
      storeResetSearch: 'application/resetSearch',
      storeResetMatchesBoxes: 'boxes/resetResult',
    }),
    launchSearch() {
      this.storeStartSearch();
      this.storeStartLoading();
      const body = (this.isUniqueFieldSearch) ? { ...this.oneFieldSearch } : { ...this.multiFieldSearch };
      this.storeSearchMatches({ ...body, sessionId: this.getterSession.token }).then(() => {
        this.storeFinishLoading();
        this.$emit('loaded-boxes');
      }).catch(() => {
        this.storeResetSearch();
        this.storeFinishLoading();
      });
    },
    resetResult() {
      this.storeResetMatchesBoxes();
      this.storeResetSearch();
      this.storeFinishLoading();
      this.$emit('reset-field');
    },
    clearField(event) {
      event.preventDefault();
      Object.keys(this.oneFieldSearch).forEach((key) => { this.oneFieldSearch[key] = ''; });
      Object.keys(this.multiFieldSearch).forEach((key) => { this.multiFieldSearch[key] = ''; });
      Object.keys(this.errors).forEach((key) => { this.errors[key] = false; });
      this.isMultiFieldSearch = false;
      this.isUniqueFieldSearch = false;
      this.storeResetMatchesBoxes();
      this.storeResetSearch();
      this.checkOnlyOneFieldCompleted();
      this.$emit('reset-field');
    },
    formHasError() {
      return Object.values(this.errors).some(value => value);
    },
    resetSingleSearch() {
      if (Object.values(this.oneFieldSearch).some(value => value !== '')) {
        this.isUniqueFieldSearch = true;
      } else {
        this.isUniqueFieldSearch = false;
      }
    },
    resetMultiSearch() {
      if (Object.values(this.multiFieldSearch).some(value => value !== '')) {
        this.isMultiFieldSearch = true;
      } else {
        this.isMultiFieldSearch = false;
      }
    },
    checkOnlyOneFieldCompleted() {
      if (Object.values(this.oneFieldSearch).reduce(((acc, value) => acc && value === ''), true)) {
        this.errors.doubleFieldCompleted = false;
        return true;
      }
      let nbCompletedField = 0;
      Object.values(this.oneFieldSearch).forEach((field) => {
        if (field !== '') {
          nbCompletedField += 1;
        }
      });
      if (nbCompletedField === 1) {
        this.errors.doubleFieldCompleted = false;
        return true;
      }
      this.errors.doubleFieldCompleted = true;
      return false;
    },
    checkPhoneNumberIsValid() {
      if (this.multiFieldSearch.phoneNumber === '') {
        this.errors.isInvalidPhoneNumber = false;
      } else if (this.multiFieldSearch.phoneNumber.length < 10) {
        this.errors.isInvalidPhoneNumber = true;
      } else {
        const phoneRegex = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;
        if (this.multiFieldSearch.phoneNumber.match(phoneRegex) === null) {
          this.errors.isInvalidPhoneNumber = true;
        } else {
          this.errors.isInvalidPhoneNumber = false;
        }
      }
    },
    checkOnlyOneTypeSearch() {
      if (this.isUniqueFieldSearch === true && this.isMultiFieldSearch === true) {
        this.errors.isOnlyOneTypeSearch = true;
      } else {
        this.errors.isOnlyOneTypeSearch = false;
      }
    },
  },
};
</script>
